import React from 'react';
import { Avatar, Tooltip } from 'antd';

export interface AvatarItem {
  label?: string;
  value: string | number; // label is for full tooltip, value is for inside avatar
}

interface AvatarGroupDisplayProps {
  items: AvatarItem[];
  maxCount?: number;
}

const generateColor = (index: number): string => {
  const colors = [
    '#1677ff', '#f56a00', '#87d068', '#722ed1', '#eb2f96',
    '#faad14', '#13c2c2', '#52c41a', '#2f54eb', '#d46b08'
  ];
  return colors[index % colors.length];
};

// 👇 Utility to get initials or fallback display text
const getAvatarText = (value: string | number): string => {
  const str = String(value).trim();

  // If it's a number or short code like "3001", show as-is
  if (!isNaN(Number(str)) || str.length <= 3) {
    return str;
  }

  // If it's a longer string, return first two letters capitalized
  const parts = str.split(/[\s_-]+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  return str.slice(0, 2).toUpperCase(); // fallback
};

const AvatarToolTip: React.FC<AvatarGroupDisplayProps> = ({
  items,
  maxCount = 3,
}) => {
  if (!items?.length) return null;

  return (
    <div className="avatar-group-tooltip">
      <Avatar.Group
        max={{
          count: maxCount,
          style: undefined,
        }}
      >
        {items.map((item, idx) => (
          <Tooltip key={idx} title={item.label || String(item.value)} placement="top">
            <Avatar
              style={{
                backgroundColor: generateColor(idx),
                cursor: 'pointer',
              }}
            >
              {getAvatarText(item.value)}
            </Avatar>
          </Tooltip>
        ))}
      </Avatar.Group>
    </div>
  );
};

export default AvatarToolTip;
